import { createAsyncThunk } from '@reduxjs/toolkit';
import { batch } from 'react-redux';

import { authSet } from '../../utils/request';
import { METHOD_POST } from '../../constants/api';
import logoOut from '../../actions/auth/auth';
import clearMyProfile from '../../actions/profile/getMyProfile';
import { resetApplicationState } from '../../actions/application/application';

const postLogout = createAsyncThunk('auth/register',
  async (_, { dispatch }) => {
    await authSet(METHOD_POST, '/logout');
    batch(() => {
      dispatch(logoOut());
      dispatch(clearMyProfile());
      dispatch(resetApplicationState());
    });
    return true;
  });

export default postLogout;
